module AgendaPage

open Shared
open System
open Elmish
open Feliz
open API
open ViewTypes
open RenderHelpers

let getItem agendaState itemid = agendaState.AgendaItems |> List.find (fun item -> item.Id=itemid)

let updateEditDate agendaState (datestr:string)=
    match agendaState.EditItem with
    | None -> None
    | Some itemId ->
        try
            let a = datestr.Split('-')
            let d= new DateTime(int a.[2], int a.[1],int a.[0])
            //let d = DateTime.ParseExact(datestr, "dd-mm-YYYY HH:mm", System.Globalization.CultureInfo.InvariantCulture)
            //let d = DateTime.Parse(datestr, System.Globalization.CultureInfo.CurrentCulture)
            

            printfn "str: %A, date: %A" datestr d
            Some {getItem agendaState itemId with Date =d}
        with
        | :? FormatException -> printfn "FormatException"; None
        | :? ArgumentOutOfRangeException -> printfn "ArgumentOutOfRangeException";None
        | :? IndexOutOfRangeException -> printfn "IndexOutOfRangeException"; None
        | :? OverflowException -> printfn "OverflowException"; None
    
let update (msg: AgendaMsg) (state: State) =
    let agendaState=state.Agenda
    let toState agendastate_ ={state with Agenda=agendastate_}
    match msg with    
    | EditAgendaClicked (guid, itemtype) ->
        //printf "%A" itemtype
        let item= getItem agendaState guid
        let stringbuffer=
            match itemtype with
            |AgendaEditItem.Date -> item.Date.ToShortDateString()
            |AgendaEditItem.Note -> item.Note
            |AgendaEditItem.Nothing-> ""


        toState {agendaState with EditItem = Some guid; StringBuffer=stringbuffer; EditDateOrNote = itemtype }, Cmd.none
    | DeleteAgendaClicked agenda -> state, Cmd.OfAsync.perform bandAidApi.verwijderDate agenda DefAgendaUpdated
    | UpdateAgendaDate ->        
        match updateEditDate state.Agenda state.Agenda.StringBuffer with
        | None -> state,Cmd.none
        | Some agendaitem ->
            //printfn "agenda: %A" agendaitem
            state, Cmd.OfAsync.perform bandAidApi.updateDates agendaitem DefAgendaUpdated
    | UpdateAgendaNote agendaitem->
        match agendaitem.Note=state.Agenda.StringBuffer with
        | true -> {state with Agenda= {state.Agenda with EditDateOrNote = AgendaEditItem.Nothing; EditItem=None}},Cmd.none
        | false -> state, Cmd.OfAsync.perform bandAidApi.updateDates {agendaitem with Note=state.Agenda.StringBuffer} DefAgendaUpdated

        //match updateEditNote state.Agenda state.Agenda.StringBuffer with
        //| None -> state,Cmd.none
        //| Some agendaitem -> state, Cmd.OfAsync.perform bandAidApi.updateDates agendaitem DefAgendaUpdated
    | AddAgendaClicked agenda -> state, Cmd.OfAsync.perform bandAidApi.addDate agenda DefAgendaUpdatedWithNewItem
    | AgendaDateChanged datestring -> toState {agendaState with StringBuffer=datestring}, Cmd.none
    | AgendaNoteChanged notestring -> toState {agendaState with StringBuffer=notestring}, Cmd.none


let renderAgendaHead  (state: State) (dispatch: Msg -> unit) =
    let levelLeft=
        Html.strong [ prop.text "Agenda" ]
        |>wrap1In Html.div "level-left"

    let levelRight =
        //let newitem=AddAgendaClicked (Agenda.create System.DateTime.Now)
        //let a= AgendaMsg newitem
        //btnElm "fa fa-file" dispatch a "has-text-danger"
        //|> wrap1In Html.div "level-right"

        if true then //state.Agenda.EditItem.IsNone
            let newitem=AddAgendaClicked (Agenda.create System.DateTime.Now "")
            btnElm "fa fa-file" dispatch (Msg.AgendaMsg newitem) "has-text-danger"
            |> wrap1In Html.div "level-right"
        else Html.none

    [ levelLeft; levelRight ]
    |> wrapxIn Html.div "level is-mobile"


let renderAgendaItem (agendaitem: AgendaItem) (itemType : AgendaEditItem) (stringbuffer: string) counter dispatch =
    let bgc =
        if counter % 2 = 0 then "has-background-white" else "has-background-white-bis"

    let inputItem itemtype=
        Html.div [
                    prop.className "field"
                    prop.children [
                        Html.p [
                            prop.className "control"
                            prop.children [
                                match itemtype with
                                |AgendaEditItem.Date ->                                
                                    Html.input [
                                        prop.className "input"
                                        prop.type' "text"
                                        prop.valueOrDefault (stringbuffer)
                                        prop.onChange (AgendaDateChanged >> dispatch)
                                        prop.onBlur (fun _ -> (dispatch UpdateAgendaDate))
                                        prop.autoFocus true
                                    ]
                                | AgendaEditItem.Note->
                                    Html.input [
                                        prop.className "input"
                                        prop.type' "text"
                                        prop.valueOrDefault (stringbuffer)
                                        prop.onChange (AgendaNoteChanged >> dispatch)
                                        prop.onBlur (fun _ -> (dispatch (UpdateAgendaNote agendaitem)))
                                        prop.autoFocus true
                                    ]
                                | _ -> Html.none
                            ]
                        ]

                    ]
                ]
    let textItem itemtype =
        let weekday (num:DayOfWeek) =
            match num with
            | DayOfWeek.Monday -> "Monday"
            | DayOfWeek.Tuesday -> "Tuesday"
            | DayOfWeek.Wednesday -> "Wednesday"
            | DayOfWeek.Thursday -> "Thursday"
            | DayOfWeek.Friday -> "Friday"
            | DayOfWeek.Saturday -> "Saturday"
            | DayOfWeek.Sunday -> "Sunday"
            | _ -> "Invalid"

        Html.div [
                    prop.className "field"
                    prop.children [                            
                            match itemtype with
                            | AgendaEditItem.Date ->
                                Html.a [
                                    prop.className "is-size-5 level-item"
                                    prop.text (agendaitem.Date.ToShortDateString() + ", " + (weekday agendaitem.Date.DayOfWeek))
                                    prop.onClick (fun _ -> dispatch (EditAgendaClicked (agendaitem.Id,AgendaEditItem.Date)))
                                ]
                            | AgendaEditItem.Note ->
                                Html.a [
                                    prop.className "is-size-5 level-item"
                                    prop.text (if agendaitem.Note = "" then "?" else agendaitem.Note)
                                    prop.onClick (fun _ -> dispatch (EditAgendaClicked (agendaitem.Id,AgendaEditItem.Note)))
                                ]
                            | _ -> Html.none
                        
                    ]
                ]

    let body ()=
        Html.div [
            prop.className ("field menu-list" + " " + bgc)
            prop.children [
                Html.div [
                    prop.className "field-body"
                    prop.children [
                        match itemType with
                        | AgendaEditItem.Date ->
                            inputItem AgendaEditItem.Date
                            textItem AgendaEditItem.Note
                        | AgendaEditItem.Note ->
                            textItem AgendaEditItem.Date
                            inputItem AgendaEditItem.Note
                        | _ ->
                            textItem AgendaEditItem.Date
                            textItem AgendaEditItem.Note                        
                        Html.div [
                            prop.className "field is-grouped is-grouped-right"
                            prop.children [
                                Html.p [
                                    prop.className "button"
                                    prop.children [
                                        Html.i [ prop.className"fas fa-times"]                                        
                                    ]
                                    prop.onClick (fun _ -> dispatch (DeleteAgendaClicked agendaitem) )
                                ]

                            ]
                        ]
                        
                ]
                ]
            ]
        ]
        
    body()


let render (state: State) (dispatch: Msg -> unit) =
    //Html.button [
    //    prop.className ("button level-item")
    //    prop.onClick (fun _ -> dispatch dispfun)
    //    prop.children [ Html.i [ prop.className "has-text-danger"] ] ]
    let itemType item =
        match state.Agenda.EditItem with
        | Some itemguid ->
            if item.Id=itemguid then state.Agenda.EditDateOrNote else AgendaEditItem.Nothing            
        | None -> AgendaEditItem.Nothing

        

    let mutable counter =0    
    Html.div [
        prop.children [
            renderAgendaHead state dispatch            
            for item in state.Agenda.AgendaItems do
                counter <- counter+1
                renderAgendaItem item (itemType item) state.Agenda.StringBuffer counter (AgendaMsg>>dispatch)
            ]
        ]
    

